export default __webpack_public_path__ + "static/media/derivar.762fac68.svg";